/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * ButtonToggle CSS
 */
export const styles = css`
  :host {
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .nile-button-toggle {
    display: flex;
    padding: var(--nile-spacing-sm, var(--ng-spacing-md))
      var(--nile-spacing-xl, var(--ng-spacing-xl))
      var(--nile-spacing-sm, var(--ng-spacing-md))
      var(--nile-spacing-14px, var(--ng-spacing-xl));
    border: 1px solid var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
    cursor: pointer;
    border-radius: var(--nile-radius-radius-xs, var(--ng-radius-md));
    font-weight: var(--nile-font-weight-medium, var(--ng-font-weight-semibold));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-700));
    text-align: center;
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-sm));
    letter-spacing: 0.2px;
    justify-content: center;
    align-items: center;
    gap: var(--nile-spacing-md, var(--ng-spacing-md));
    height: 40px;
    box-sizing: border-box;
  }

  .nile-button-toggle:hover {
    background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary-hover));
  }

  .nile-button-toggle:active {
    background: var(--nile-colors-neutral-400, var(--ng-colors-bg-primary-hover));
  }

  .nile-button-toggle__initial {
    border-radius: 
    var(--nile-radius-radius-xs, var(--ng-radius-md)) 
    var(--nile-radius-radius-none, var(--ng-radius-none)) 
    var(--nile-radius-radius-none, var(--ng-radius-none)) 
    var(--nile-radius-radius-xs, var(--ng-radius-md));
  }

  .nile-button-toggle__end {
    border-radius: 
    var(--nile-radius-radius-none, var(--ng-radius-none))
    var(--nile-radius-radius-xs, var(--ng-radius-md))
    var(--nile-radius-radius-xs, var(--ng-radius-md))
    var(--nile-radius-radius-none, var(--ng-radius-none));
    border-left: var(--nile-radius-radius-none, var(--ng-radius-none));
  }

  .nile-button-toggle__middle {
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: var(--nile-colors-neutral-500, var(--ng-colors-border-primary));
    border-radius: var(--nile-radius-radius-none, var(--ng-radius-none));
  }

  .nile-button-toggle__active {
    background-color: var( --nile-colors-neutral-500, var(--ng-colors-bg-primary-hover) );
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-hover));
  }

  .nile-button-toggle__active:hover {
    background-color: var(--nile-colors-neutral-500, var(--ng-colors-bg-primary-hover));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-hover));
  }

  .nile-button-toggle__disabled {
    cursor: not-allowed;
  }
`;

export default [styles];
